"use client";

import Button from "@/components/ui/Button";
import { PopoverTrigger } from "@/components/ui/Popover";
import { PropsWithChildren } from "react";

const SortButton = ({ children }: PropsWithChildren) => {
  return (
    <PopoverTrigger asChild>
      <Button mode="unset" modal={"sort"} popover={undefined} block>
        {children}
      </Button>
    </PopoverTrigger>
  );
};

export default SortButton;
